import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
// import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import {
  CalendarIcon,
  ChevronLeft,
  ChevronRight,
  Eye,
  IdCard,
  ListIcon,
  Pencil,
} from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
// import moment from 'moment';
// import WeekRangePicker from '../../../../../component/ui/calendar/custom';
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
// import ChangeHolidayStatus from '../../../../../component/popup/change-holiday-status';
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import XCloseIcon from "../../../../component/icons/x-close";
import Chip from "../../../../component/ui/chip";
// import ProjectQuickView from "../projects/project/popup";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import LeadQuickView from "../../../mainleads/leads/lead/popup";
import ContactQuickView from "../../../mainAccounts/accounts/contact/popup";
import AccountQuickView from "../../../mainAccounts/accounts/account/popup";
import DealQuickView from "../../../mainDeals/deals/deal/popup";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import ProjectQuickView from "../../../projects/project/popup";

const Card = ({ className = "", children }) => (
  <div
    className={`bg-white rounded-2xl shadow-sm border border-gray-200 ${className}`}
  >
    {children}
  </div>
);
const CardBody = ({ className = "", children }) => (
  <div className={`p-4 ${className}`}>{children}</div>
);

const DealList = () => {
  const masterCheckboxRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [quickViewType, setQuickViewType] = useState(null);
  const [empData, setEmpData] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    // getHolidays()
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `activities/get-logs?scope=organization${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const handleToggleAll = () => {
    const allIds = apiData.map(
      (ele) => `${ele.employee_id}---${ele.holiday_id}`
    );
    const isAllChecked = selectedIds?.length === allIds?.length;
    setSelectedIds(isAllChecked ? [] : allIds);
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setChangeModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onStatusChange = (value) => {
    setCurrentStatus(value);
    setChangeModal(true);
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Activities"} />
                ) : (
                  <div className="w-full h-full !overflow-auto">

                    <Table
                      ref={tableRef}
                      
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky>
                            <TableHeaderWrap>
                              <span className="pl-[50px]">User Details</span>
                            </TableHeaderWrap>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Email</span>
                            </div>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Phone</span>
                            </div>
                          </TableCell>
                          {tableHeader?.map((eachHead, index) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <TableCell header key={index}>
                                <TableHeaderWrap>
                                  <span>{eachHead?.value}</span>
                                </TableHeaderWrap>
                              </TableCell>
                            ) : null
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {apiData?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              <TableCell sticky>
                                <div
                                  className={`${Style.tableActionArea} !gap-4`}
                                >
                                  {eachList?.entity?.contact_info ? (
                                    <>
                                      <div className="flex items-center gap-3">
                                        <div>
                                          {eachList?.entity?.contact_info
                                            ?.userimg ? (
                                            <img
                                              className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                              src={
                                                eachList?.entity?.contact_info
                                                  ?.userimg
                                              }
                                              alt={
                                                eachList?.entity?.contact_info
                                                  ?.name
                                              }
                                              onError={(e) => {
                                                e.target.classList.add(
                                                  "hidden"
                                                );
                                                if (e.target.parentElement) {
                                                  e.target.parentElement.innerHTML = `
                                          <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                            ${
                                              eachList?.entity?.contact_info?.name?.split(
                                                " "
                                              )[0]?.[0] || ""
                                            }${
                                                    eachList?.entity?.contact_info?.name?.split(
                                                      " "
                                                    )[1]?.[0] || ""
                                                  }
                                          </div>`;
                                                }
                                              }}
                                            />
                                          ) : (
                                            <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                              {eachList?.entity?.contact_info?.name?.split(
                                                " "
                                              )[0]
                                                ? eachList?.entity?.contact_info?.name?.split(
                                                    " "
                                                  )[0][0]
                                                : ""}
                                              {eachList?.entity?.contact_info?.name?.split(
                                                " "
                                              )[1]
                                                ? eachList?.entity?.contact_info?.name?.split(
                                                    " "
                                                  )[1][0]
                                                : ""}
                                            </div>
                                          )}
                                        </div>
                                        <div className="font-medium leading-5">
                                          {eachList?.entity?.contact_info?.name}
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            setEmpData(eachList);
                                            setQuickViewType(
                                              eachList?.entity?.type
                                            );
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#007AFF" }}
                                          >
                                            <NewEyeIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </TableCell>
                              <TableCell>
                                {/* {eachList?.entity?.contact_info?.email || "-"} */}
                                {eachList?.entity?.contact_info?.email ? (
                                  <a
                                    href={
                                      `mailto:${eachList?.entity?.contact_info?.email}` ||
                                      ""
                                    }
                                  >
                                    {eachList?.entity?.contact_info?.email ||
                                      "--"}
                                  </a>
                                ) : (
                                  "--"
                                )}
                              </TableCell>
                              <TableCell>
                                {eachList?.entity?.contact_info?.phone || "--"}
                              </TableCell>
                              {tableHeader?.map((eachHead, i) =>
                                eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                  <>
                                    {eachHead.key === "user_type" ? (
                                      <TableCell key={`${i}-${index}`}>
                                        {eachList?.user_type === "Contact"
                                          ? "Lead"
                                          : eachList?.user_type}
                                      </TableCell>
                                    ) : // : eachHead?.key == "entity" ? (
                                    //   <TableCell key={`${i}-${index}`}>
                                    //     {eachList?.entity?.type ?? "-"}
                                    //   </TableCell>
                                    // )
                                    eachHead?.key == "entity" ? (
                                      <TableCell
                                        key={`${i}-${index}`}
                                        className="capitalize text-center"
                                      >
                                        {eachList?.entity?.type == "lead" ? (
                                          <Chip color="orange">Lead</Chip>
                                        ) : eachList?.entity?.type == "deal" ? (
                                          <Chip color="blue">Deal</Chip>
                                        ) : eachList?.entity?.type ==
                                          "contact" ? (
                                          <Chip color="green">Contact</Chip>
                                        ) : eachList?.entity?.type ==
                                          "account" ? (
                                          <Chip color="sky">Account</Chip>
                                        ) : eachList?.entity?.type ==
                                          "project" ? (
                                          <Chip color="blue">Project</Chip>
                                        ) : (
                                          <Chip color="gray">-</Chip>
                                        )}
                                      </TableCell>
                                    ) : eachHead.key === "user" ? (
                                      <>
                                        {eachList?.user ? (
                                          <TableCell key={`${i}-${index}`}>
                                            <div className="flex items-center gap-3">
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.user?.userimg ? (
                                                  <img
                                                    src={`${eachList?.user?.userimg}`}
                                                    alt={eachList?.user?.name}
                                                    className="h-9 w-9 shrink-0 rounded-full object-cover object-center"
                                                    onError={(e) => {
                                                      e.target.classList.add(
                                                        "hidden"
                                                      );
                                                      if (
                                                        e.target.parentElement
                                                      ) {
                                                        e.target.parentElement.innerHTML = `
                                              <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                ${
                                                  eachList?.user?.name?.split(
                                                    " "
                                                  )[0]?.[0] || ""
                                                }${
                                                          eachList?.user?.name?.split(
                                                            " "
                                                          )[1]?.[0] || ""
                                                        }
                                              </div>`;
                                                      }
                                                    }}
                                                  />
                                                ) : (
                                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                    {eachList?.user?.name?.split(
                                                      " "
                                                    )[0]?.[0] || ""}
                                                    {eachList?.user?.name?.split(
                                                      " "
                                                    )[1]?.[0] || ""}
                                                  </div>
                                                )}
                                              </div>
                                              <span className="font-medium">
                                                {eachList?.user?.name || "-"}
                                              </span>
                                            </div>
                                          </TableCell>
                                        ) : (
                                          <TableCell key={`${i}-${index}`}>
                                            --
                                          </TableCell>
                                        )}
                                      </>
                                    ) : (
                                      <TableCell key={`${i}-${index}`}>
                                        {eachList[eachHead?.key] ?? "-"}
                                      </TableCell>
                                    )}
                                  </>
                                ) : null
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </div>

              {/* {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${
                      tablePagination?.total || apiData?.length
                    }`}
                  </div>

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            // setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            // filterData({ page: pageCount + 1, btnCall: true });
                            getData({
                              page: tablePagination?.next_page_url,
                            });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-logs"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-logs"
        />
      )}

      {quickViewType === "deal" && (
        <DealQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, dealid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "lead" && (
        <LeadQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, leadid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "contact" && (
        <ContactQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "account" && (
        <AccountQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "project" && (
        <ProjectQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, projectkey: empData?.entity?.data?.projectkey }}
        />
      )}

      {/* {changeModal &&
        <ChangeHolidayStatus onClose={() => {setChangeModal(false); setCurrentStatus("")}} onSubmit={onSuccess} onError={onError} selectedList={selectedIds} selectedStatus={currentStatus} />
      } */}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DealList;
